import React from 'react';
import { connect } from 'react-redux';
import Translation from '../../utilities/localizationUtility';
import Button from '../../components/Common/Button';
import Message from '../../components/Alert/message';
import LoadingButton from './LoadingButton';

const Index = (props) => {
  const {
    onSubmit, canBook, settings, labelPrefix, label, loading, messages, className, loadingKeys,
  } = props;
  const { style } = settings;
  const fontSize = style.body.fontSize || '16px';
  const backgroundColor = canBook ? style.button.backgroundColor : style.inactive.backgroundColor;
  const buttonStyle = { ...style.button, ...{ fontSize, backgroundColor } };
  const t = new Translation(settings);
  const buttonLabel = label || (loading || canBook ? t.key('submit') : t.key('noAvailability'));
  const hasErrors = !!messages && messages.length > 0;
  const errorStyles = { display: hasErrors ? 'block' : 'none' };
  const isLoading = loadingKeys && loadingKeys.length > 0;

  if (isLoading) {
    return <LoadingButton style={style} />;
  }

  return (
    <>
      <Button
        className={className}
        styled={buttonStyle}
        disabled={!canBook}
        submit
        onClick={(e) => onSubmit(e)}
      >
        {labelPrefix}
        {buttonLabel}
      </Button>
      {hasErrors && <div style={errorStyles} className='alert red show'>
        {messages.map((m) => (
          <Message key={m} message={m} type={'red'} />
        ))}
      </div>}
    </>
  );
};

export default connect(({ settings, ui }) => ({
  settings,
  loadingKeys: ui.loadingKeys,
}))(Index);
